import IMask from 'imask'
import Bouncer from 'formbouncerjs'
import Forms from '../partials/forms'
import apiFetch from '@wordpress/api-fetch'

const Contact = () => {
  const form = document.querySelector('.contactform')
  const inputSubject = document.querySelector('[name="subject"]')
  const inputFile = document.querySelectorAll('.file-block')
  const inputSponsorship = document.querySelectorAll('.sponsorship')
  const inputVisits = document.querySelectorAll('.visits')
  const inputPartnership = document.querySelectorAll('.partnership')
  const inputContact = document.querySelector('.talk-with-us')
  const selectStates = document.querySelector('.select-states')
  const selectCities = document.querySelector('.select-cities')
  const defaultOption = selectCities
    ? selectCities.querySelector('option[value=""]')
    : false
  const selectCitiesLoad = document.querySelector(
    '.select-cities ~ .loading-spinner'
  )
  const formLoad = document.querySelector('.button-box .loading-spinner')
  const formBtn = document.querySelector('.button-box .btn')

  const name = document.querySelector('.name')
  const cellphone = document.querySelector('.cellphone')
  const phone = document.querySelector('.phone')
  const investment = document.querySelector('.investment')

  if (name) {
    let nameMask = IMask(name, {
      mask: /^([^0-9]*)$/,
    })
  }

  if (cellphone) {
    let cellphoneMask = IMask(cellphone, {
      mask: '(00) 00000-0000',
    })
  }

  if (phone) {
    let phoneMask = IMask(phone, {
      mask: '(00) 00000-0000',
    })
  }

  if (investment) {
    let investmentMask = IMask(investment, {
      mask: [
        { mask: '' },
        {
          mask: 'R$ num',
          lazy: false,
          blocks: {
            num: {
              mask: Number,
              scale: 2,
              thousandsSeparator: '.',
              padFractionalZeros: true,
              radix: ',',
              mapToRadix: ['.'],
            },
          },
        },
      ],
    })
  }

  new Bouncer(`.form`, {
    fieldClass: 'error-field',
    disableSubmit: true,
    ...Forms.wrongMessages(),
  })

  if (inputSubject) {
    inputSubject.addEventListener('change', (input) => {
      if (input.target.value == 1) {
        inputSponsorship.forEach((element) => {
          element.classList.add('show')
          changeRequired(element, 'add')
        })

        inputVisits.forEach((element) => {
          element.classList.remove('show')
          changeRequired(element, 'remove')
        })

        inputPartnership.forEach((element) => {
          element.classList.remove('show')
          changeRequired(element, 'remove')
        })

        inputContact.classList.remove('show')
        inputContact.querySelector('textarea').required = false
      } else if (input.target.value == 2) {
        inputVisits.forEach((element) => {
          element.classList.add('show')
          changeRequired(element, 'add')
        })

        inputSponsorship.forEach((element) => {
          element.classList.remove('show')
          changeRequired(element, 'remove')
        })

        inputPartnership.forEach((element) => {
          element.classList.remove('show')
          changeRequired(element, 'remove')
        })

        inputContact.classList.remove('show')
        inputContact.querySelector('textarea').required = false
      } else if (input.target.value == 3) {
        inputPartnership.forEach((element) => {
          element.classList.add('show')
          //changeRequired(element, 'add')
        })

        inputSponsorship.forEach((element) => {
          element.classList.remove('show')
          changeRequired(element, 'remove')
        })

        inputVisits.forEach((element) => {
          element.classList.remove('show')
          changeRequired(element, 'remove')
        })


      } else {
        inputVisits.forEach((element) => {
          element.classList.remove('show')
          changeRequired(element, 'remove')
        })

        inputSponsorship.forEach((element) => {
          element.classList.remove('show')
          changeRequired(element, 'remove')
        })

        inputPartnership.forEach((element) => {
          element.classList.remove('show')
          changeRequired(element, 'remove')
        })

        inputContact.classList.add('show')
        inputContact.querySelector('textarea').required = true
      }
    })
  }

  function changeRequired(element, type) {
    let status = type == 'add' ? true : false
    let fields = element.querySelectorAll('input, textarea, select')
    if (fields) {
      fields.forEach((field) => {
        if (!element.classList.contains('optional')) {
          field.required = status
        } else {
          field.required = false
        }
      })
    }
  }

  if (inputFile) {
    inputFile.forEach((element) => {
      element.querySelector('[name="project"]').addEventListener('change', (input) => {
        element.querySelector('.filename').textContent =
          input.target.files[0].name
      })
    })
  }

  if (selectStates) {
    selectStates.addEventListener('change', () => {
      if (selectStates.value) {
        callCities(selectStates.selectedOptions[0].dataset.stateCode)
      } else {
        selectCities.innerHTML = ''
        selectCities.appendChild(defaultOption)
        selectCities.disabled = true
      }
    })
  }

  function callCities(stateID) {
    let data = new FormData()
    data.append('action', 'callCities')
    data.append('id', stateID)

    selectCities.disabled = true
    selectCitiesLoad.classList.add('show')

    fetch(ajaxurl, {
      method: 'POST',
      body: data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then((response) => response.json())
      .then((citiesArray) => {
        selectCities.innerHTML = ''
        selectCities.appendChild(defaultOption)

        citiesArray.forEach((city) => {
          const option = document.createElement('option')
          option.value = city
          option.textContent = city
          selectCities.appendChild(option)
        })

        selectCities.disabled = false
        selectCitiesLoad.classList.remove('show')
      })
      .catch((error) => {
        console.error('Erro na requisição:', error)
      })
  }

  // Detect show error events
  document.addEventListener(
    'bouncerShowError',
    function (event) {
      // The field with the error
      var field = event.target

      // The error details
      // var errors = event.details.errors;
    },
    false
  )

  form.addEventListener('bouncerFormValid', (event) => {
    event.preventDefault()

    grecaptcha.ready(function () {
      grecaptcha
        .execute('6Ldiep8mAAAAAGoTQZ_KnnCM5wscI3ejdx1l90bu', {
          action: 'submit',
        })
        .then(function (token) {
          if (token) {
            formLoad.classList.add('show')
            formBtn.disabled = true
            apiFetch({
              path: '/wp-json/basedigital/v1/contact',
              method: 'POST',
              body: new FormData(form),
            })
              .then((res) => {
                document.querySelector('.success').classList.add('show')
                document.querySelector('.success').scrollIntoView(true)
                formLoad.classList.remove('show')
                formBtn.disabled = false
                form.reset()
              })
              .catch((err) => {
                formBtn.disabled = false
                // formBtn.classList.add('wrong')
                setTimeout(() => {
                  // formBtn.classList.remove('wrong')
                  if(document.querySelector('.wrong')){
                    document.querySelector('.wrong').classList.add('show')
                    document.querySelector('.wrong').scrollIntoView(true)
                    
                  }
                  formLoad.classList.remove('show')
                }, 2000)
              })
          }
        })
    })
  })
}

export default Contact
